var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKyrgyzstan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40 31.0456 40 19.9999C40 8.95424 31.0457 -6.10352e-05 20 -6.10352e-05C8.95431 -6.10352e-05 0 8.95424 0 19.9999C0 31.0456 8.95431 39.9999 20 39.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.781 19.9998L25.7845 21.8797L27.9127 25.7505L23.5727 24.9201L23.023 29.3042L19.9999 26.08L16.9771 29.3042L16.4272 24.9201L12.0875 25.7504L14.2156 21.8795L10.219 19.9998L14.2156 18.12L12.0875 14.2491L16.427 15.0796L16.9773 10.6954L19.9999 13.9197L23.0231 10.6954L23.5727 15.0796L27.9129 14.2491L25.7846 18.1203L29.781 19.9998Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 26.0868C23.3618 26.0868 26.087 23.3616 26.087 19.9999C26.087 16.6381 23.3618 13.9129 20 13.9129C16.6383 13.9129 13.9131 16.6381 13.9131 19.9999C13.9131 23.3616 16.6383 26.0868 20 26.0868Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9565 19.9999C16.8099 19.9999 16.6651 20.0074 16.5222 20.0216C16.5275 20.8646 16.8325 21.6363 17.3362 22.2357C17.605 21.5125 18.0062 20.8531 18.5122 20.2887C18.0289 20.1028 17.5046 19.9999 16.9565 19.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8301 23.2758C19.1957 23.4064 19.5894 23.4781 20 23.4781C20.4106 23.4781 20.8043 23.4064 21.1699 23.2758C20.9706 22.4936 20.5591 21.7953 20 21.2466C19.4409 21.7953 19.0294 22.4936 18.8301 23.2758Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0121 18.2612C22.4107 17.2217 21.2875 16.5215 20 16.5215C18.7125 16.5215 17.5893 17.2216 16.9879 18.2612C18.0843 18.2668 19.1124 18.5649 20 19.0797C20.8876 18.5649 21.9156 18.2668 23.0121 18.2612Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4877 20.2887C21.9937 20.853 22.3949 21.5125 22.6637 22.2357C23.1674 21.6363 23.4724 20.8646 23.4777 20.0216C23.3347 20.0073 23.1899 19.9999 23.0434 19.9999C22.4954 19.9998 21.9711 20.1028 21.4877 20.2887V20.2887Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyrgyzstan);
export default __webpack_public_path__ + "static/media/kyrgyzstan.53d9aab0e6f133a53e2d2dd99ea15d99.svg";
export { ForwardRef as ReactComponent };